import { useEffect } from 'react';
import { useValidate } from '@rmc/webcx-web-libs';
import { usePopupsApiGet } from '../api/v3/web/popups/post';
import { campaignSchema } from '../zod/campaignSchema';
import { CampaignType } from '../types/campaignsApiResponse';

type CampaignsType = {
	id: string;
	visit: number;
}[];

export function useGetValidCampaigns({
	device,
	userId,
	sessionId,
	domainScopedSessionId,
	previewQuery,
	onLog,
	campaigns,
	clientId,
}: {
	device: string;
	userId: string;
	sessionId: string;
	domainScopedSessionId: string;
	previewQuery: object;
	onLog: Function;
	campaigns: CampaignsType;
	clientId: string;
}) {
	const {
		data: apiResponse = [],
		error,
		fetchStatus,
		isLoading,
	} = usePopupsApiGet({
		campaigns,
		clientId,
		sessionId,
		domainScopedSessionId,
		userId,
		device,
		previewQuery,
	});

	useEffect(() => {
		if (isLoading) {
			return;
		}

		onLog({
			isLoading,
			error,
		});
	}, [fetchStatus, isLoading, error, campaigns]);

	const { valid: validCampaigns, invalid: invalidCampaigns } =
		useValidate<CampaignType>(apiResponse, campaignSchema, onLog);

	return {
		campaigns: validCampaigns,
		initialCampaigns: apiResponse,
		invalidCampaigns,
		isLoading,
		error,
	};
}
